.changeIndicator {
	position: relative;
	right: 2px;
	top: 5px;
}
